import React, { FC } from 'react';
import useTheme from 'evcharging/hooks/useTheme';
import { css } from '@emotion/css';
import Spacer from 'evcharging/components/Spacer';
import { Theme } from 'evcharging/app/themes';

export interface SoftwareItemProps {
  title: string;
  text: string;
  icon: any;
  fontSize?: number;
  lineHeight?: number;
}

const SoftwareItem: FC<SoftwareItemProps> = (props) => {
  const { text, title, icon } = props;
  const theme = useTheme();
  const styles = createStyles(theme, props);

  return (
    <div>
      {/*<Image src={icon} alt={title} width={35} height={35} />*/}
      <Spacer value={64} mobile={0} />
      <h4 className={styles.title}>{title}</h4>
      <Spacer value={12} />
      <p className={styles.text}>{text}</p>
    </div>
  );
};

const createStyles = (theme: Theme, { fontSize = 16, lineHeight = 24 }: SoftwareItemProps) => ({
  title: css`
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 28px;
    letter-spacing: -0.019em;
    color: #000;
  `,
  text: css`
    font-weight: 400;
    font-size: ${fontSize}px;
    line-height: ${lineHeight}px;
    letter-spacing: -0.011em;
    color: #6e7c87;
    padding-bottom: 12px;
    max-width: 327px;
    ${theme.breakpoints.mobile.down} {
      padding-bottom: 0;
    }
  `,
});

export default SoftwareItem;
